// extracted by mini-css-extract-plugin
export default {"sendToAppBannerContainer":"_367gp","title":"hcVg9","appReviews":"+ZjMO","mobileDevicesImage":"_9UFHH","downloadCta":"AkMeI"};